import { callbackOf, combineActions } from '../helpers.js'

export default function FlowControlCommands(context) {
    let { evaluate, dispatch } = context;

    function Do(...args) { return args.pop(); }

    function _If(cond, T, F) {
        let which = evaluate(cond);
        return evaluate(which ? T : F)
    }

    function _Case(aCase, ...rest) {
        aCase = [].concat(aCase);
        let [cond, expr] = aCase;
        let matchedCase  = evaluate(cond);
        return (matchedCase) ? (aCase.length > 1 ? evaluate(expr) : matchedCase) :
               (rest.length) ? _Case(...rest)
                             : null;
    }

    function _When(condition, callback, seconds) {
        let cb     = callbackOf(callback || 'WhenResult');
        let result = (r) => evaluate(cb(r));
        let failed = false;
        let delay  = evaluate(seconds);
        if (delay > 0) {
            setTimeout(() => failed = true, delay * 1000);
        }
        setTimeout(function tryNext() {
            let passed = !failed && evaluate(condition);
            return (failed) ? result(false) :
                   (passed) ? result(passed)
                            : setTimeout(tryNext, 500);
        });
    }

    function _OnNextPageLoad(...actions) {
        let action = combineActions(...actions);
        if (action.length > 0) {
            dispatch({ type: 'ADD_PAGE_LOAD_ACTION', payload: { action } });
        }
    }

    function _Delay(seconds, expr) {
        let millis = parseInt(evaluate(seconds)) * 1000;
        return setTimeout(() => evaluate(expr), millis);
    }

    function Cancel(delayId) {
        return clearTimeout(delayId);
    }

    return { Do, _If, _Case, _When, _OnNextPageLoad, _Delay, Cancel };
}


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/command-action-handler/src/commands/flow-control.js